import * as fromReducer from './available-lookup-os-update.reducer';
import { DevicesRouterStoreSelectors } from '../router';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export const selectAvailableLookupOsUpdateState = createFeatureSelector(fromReducer.AvailableLookupOsUpdateFeatureKey);

export const selectAvailableLookupOsUpdate = createSelector(
  selectAvailableLookupOsUpdateState,
  fromReducer.selectAvailableLookupOsUpdate
);

export const selectAvailableLookupOsUpdateIds = createSelector(
  selectAvailableLookupOsUpdateState,
  fromReducer.selectAvailableLookupOsUpdateIds
);

export const selectAvailableLookupOsUpdateEntities = createSelector(
  selectAvailableLookupOsUpdateState,
  fromReducer.selectAvailableLookupOsUpdateEntities
);

export const selectAvailableLookupOsUpdateByUdid = createSelector(
  selectAvailableLookupOsUpdate,
  DevicesRouterStoreSelectors.selectUdid,
  (availableLookupOsUpdate, udid) => availableLookupOsUpdate.filter((a) => a.udid === udid)
);
